<template>
  <v-container>
    <v-card class="elevation-4">
      <v-card-text>
        <h3 class="headline mb-4">
          {{ $t('Edit user "%s %s"', original.firstname, original.lastname) }}
        </h3>
      </v-card-text>
      <v-card-text>
        <EditorBasic></EditorBasic>
      </v-card-text>
      <v-card-actions class="justify-end pa-5">
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="!hasChanges"
          @click="saveUser"
        >
          {{ $t('Save changes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<style lang="sass" scoped>
@import '~vuetify/src/styles/styles.sass'
@media #{map-get($display-breakpoints, 'md-and-up')}
  .sticky-float
    position: sticky
    top: 100px
</style>
<script>
import { mapGetters } from 'vuex'
import EditorBasic from './editor/Basic'

export default {
  components: {
    EditorBasic
  },

  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    init: true,
    saving: false
  }),
  computed: {
    ...mapGetters(['appReady']),
    original() {
      return this.$store.state.users.users[this.userId]
    },
    submitting() {
      return this.saving || this.publishing
    },
    hasChanges() {
      return this.$store.getters['users/editorHasChanges']
    }
  },
  watch: {
    async appReady(status) {
      if (status) {
        await this.initEditor()
      }
    }
  },
  async created() {
    let me = this
    me.$debug('created', me.userId)
    await me.initEditor()
  },

  methods: {
    async initEditor() {
      let me = this
      if (!me.appReady) {
        return false
      }
      await me.$store.dispatch('users/loadUserToEditor', me.userId)
      me.init = false
    },
    async saveUser() {
      let me = this
      try {
        me.saving = true
        me.$debug('saveUser', me.form)
        await me.$store.dispatch('users/updateUserInEditor')
        me.saving = false
        me.$toast({
          type: 'success',
          message: 'Changes saved'
        })

        await me.$redirect({
          name: 'users',
          params: { organisationId: me.original.organisation }
        })
      } catch (err) {
        if (err.message !== 'cancel') {
          me.$error(err)
        }
      }
    }
  }
}
</script>
